// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var ProvisionedFrom;
(function (ProvisionedFrom) {
    ProvisionedFrom["UNKNOWN_PLATFORM"] = "UNKNOWN_PLATFORM";
    ProvisionedFrom["WAM"] = "WAM";
    ProvisionedFrom["SALESFORCE"] = "SALESFORCE";
    ProvisionedFrom["FLEXIBLE_PROVISIONING"] = "FLEXIBLE_PROVISIONING";
})(ProvisionedFrom || (ProvisionedFrom = {}));
export var ProvisionedFrom_index;
(function (ProvisionedFrom_index) {
    ProvisionedFrom_index[ProvisionedFrom_index["UNKNOWN_PLATFORM"] = 0] = "UNKNOWN_PLATFORM";
    ProvisionedFrom_index[ProvisionedFrom_index["WAM"] = 1] = "WAM";
    ProvisionedFrom_index[ProvisionedFrom_index["SALESFORCE"] = 2] = "SALESFORCE";
    ProvisionedFrom_index[ProvisionedFrom_index["FLEXIBLE_PROVISIONING"] = 3] = "FLEXIBLE_PROVISIONING";
})(ProvisionedFrom_index || (ProvisionedFrom_index = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNKNOWN"] = "UNKNOWN";
    LocationType["REGULAR"] = "REGULAR";
    LocationType["DEMO"] = "DEMO";
    LocationType["DEV"] = "DEV";
    LocationType["TEST"] = "TEST";
})(LocationType || (LocationType = {}));
export var LocationType_index;
(function (LocationType_index) {
    LocationType_index[LocationType_index["UNKNOWN"] = 0] = "UNKNOWN";
    LocationType_index[LocationType_index["REGULAR"] = 1] = "REGULAR";
    LocationType_index[LocationType_index["DEMO"] = 2] = "DEMO";
    LocationType_index[LocationType_index["DEV"] = 3] = "DEV";
    LocationType_index[LocationType_index["TEST"] = 4] = "TEST";
})(LocationType_index || (LocationType_index = {}));
export var ProvisioningStatus;
(function (ProvisioningStatus) {
    ProvisioningStatus["PROVISION_UNKNOWN"] = "PROVISION_UNKNOWN";
    ProvisioningStatus["PROVISION_YES"] = "PROVISION_YES";
    ProvisioningStatus["PROVISION_NO"] = "PROVISION_NO";
    ProvisioningStatus["PROVISION_ERROR"] = "PROVISION_ERROR";
    ProvisioningStatus["PROVISION_SUBMITTED"] = "PROVISION_SUBMITTED";
    ProvisioningStatus["PROVISION_INPROGRESS"] = "PROVISION_INPROGRESS";
})(ProvisioningStatus || (ProvisioningStatus = {}));
export var ProvisioningStatus_index;
(function (ProvisioningStatus_index) {
    ProvisioningStatus_index[ProvisioningStatus_index["PROVISION_UNKNOWN"] = 0] = "PROVISION_UNKNOWN";
    ProvisioningStatus_index[ProvisioningStatus_index["PROVISION_YES"] = 1] = "PROVISION_YES";
    ProvisioningStatus_index[ProvisioningStatus_index["PROVISION_NO"] = 2] = "PROVISION_NO";
    ProvisioningStatus_index[ProvisioningStatus_index["PROVISION_ERROR"] = 3] = "PROVISION_ERROR";
    ProvisioningStatus_index[ProvisioningStatus_index["PROVISION_SUBMITTED"] = 4] = "PROVISION_SUBMITTED";
    ProvisioningStatus_index[ProvisioningStatus_index["PROVISION_INPROGRESS"] = 5] = "PROVISION_INPROGRESS";
})(ProvisioningStatus_index || (ProvisioningStatus_index = {}));
export const LocationProvisionerAPI = {
    ProvisionLocationFromSalesforce(fn, req) {
        return fn(`/location/v1/provision/salesforce`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetProvisionerStatus(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/location/v1/provision/status/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    /**
     * gives the latest sf pre-provision records found in location-provisioner for all the location in hierarchy for the given location id
     */
    GetPreProvisionRecords(fn, req) {
        return fn(`/location/v1/provision/preprovisionrecord`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * gives the latest sf accounts found in location-provisioner for all the location in hierarchy for the given opportunity ids
     */
    GetSalesforceAccountsByOpportunityIds(fn, req) {
        return fn(`/location/v1/provision/location-provisioner/salesforce-accounts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ProvisionLocationFromWam(fn, req) {
        return fn(`/location/v1/provision/wam`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetHierarchyBySlug(fn, req) {
        return fn(`/location/v1/provision/flexible/hierarchy?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ProvisionLocations(fn, req) {
        return fn(`/location/v1/provision/flexible/provision`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetLocationsProvisioningStatusRequest accepts list of provisioner ids and returns the provisioning
     * status along with error if present for each
     */
    GetLocationsProvisioningStatus(fn, req) {
        return fn(`/location/v1/provision/flexible/provisioner/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ProvisionSoftwareOnlyLocation(fn, req) {
        return fn(`/location/v1/provision/softwareonly`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ValidatePhoneNumber checks if a given number is a valid phone number, in an acceptable format, and not a toll-free
     */
    ValidateAndUpdatePhoneNumber(fn, req) {
        return fn(`/location/v1/provision/phonenumber/validate`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
